import React from "react";

import { Toolbar, Grid } from "@material-ui/core";

import logo from "./logo_full_light.png";

import "./App.css";

const Header: React.FC = () => {
  return (
    <Toolbar className="App-header">
      <Grid
        container
        direction="row"
        justify="flex-start"
        alignItems="center"
        style={{ height: "100%" }}
      >
        <Grid item xs="auto" style={{ height: "100%" }}>
          <img className="App-logo" src={logo} alt="fortek" />
        </Grid>
      </Grid>
    </Toolbar>
  );
};

export default Header;
